import React from 'react'
import PropTypes from 'prop-types'
import { Modal, Form, Input } from 'antd'
import { defineMessages } from 'react-intl'

const messages = defineMessages({
  alertSentEmail: '密碼重設信件將寄至{who}的信箱{email}，請查收您的信件',
  title: '忘記密碼',
  labelEmailOrUsername: '請輸入Email 或是 用戶名稱',
  buttonConfirm: '確認',
  buttonSubmit: '取得新密碼',
})

class ForgotPasswordModal extends React.Component {
  static contextTypes = {
    intl: PropTypes.object,
  };

  static propTypes = {
    emailOrUsername: PropTypes.string,
    show: PropTypes.bool,
    onHide: PropTypes.func,
    onSubmit: PropTypes.func,
    isLoading: PropTypes.bool,
    isSuccess: PropTypes.bool,
    errorMessage: PropTypes.string,
    init: PropTypes.func,
  };

  constructor (props) {
    super(props)
    this.state = {
      emailOrUsername: props.emailOrUsername || '',
      errorMessage: ''
    }
  }

  componentWillReceiveProps (nextProps) {
    if (!this.props.show && nextProps.show) {
      this.setState((prevState) => ({
        emailOrUsername: nextProps.emailOrUsername,
        errorMessage: '',
      }))
    }
    if (this.props.show && nextProps.show) {
      this.setState({
        errorMessage: nextProps.errorMessage
      })
    }
    if (this.props.show && !nextProps.show) {
      this.props.init()
    }
  }

  onEmailOrUsernameChange = (event) => {
    this.setState({
      emailOrUsername: event.target.value
    })
  }

  preventDefaultSubmit = (event) => {
    event.preventDefault()
    this.onSubmit()
  }

  validateEmail = (email) => {
    // eslint-disable-next-line
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email)
  }

  onSubmit = () => {
    const {
      onSubmit,
    } = this.props
    const {
      emailOrUsername
    } = this.state
    const isEmail = this.validateEmail(emailOrUsername)
    onSubmit({
      ...isEmail && { email: emailOrUsername },
      ...!isEmail && { username: emailOrUsername },
    })
  }

  renderSuccessMessage = () => {
    const {
      intl: { formatMessage },
    } = this.context

    const {
      emailOrUsername
    } = this.state
    const isEmail = this.validateEmail(emailOrUsername)
    const email = isEmail ? emailOrUsername : ''
    return formatMessage(messages.alertSentEmail, { email })
  }

  render () {
    const {
      intl: { formatMessage },
    } = this.context
    const {
      show,
      onHide,
      isLoading,
      isSuccess,
      form
    } = this.props
    const {
      emailOrUsername,
      errorMessage,
    } = this.state
    const { getFieldDecorator } = form

    return (
      <div>
        <Modal
          title={formatMessage(messages.title)}
          visible={show}
          onOk={this.handleOk}
          onCancel={this.props.onHide}
        >
          <Form onSubmit={this.handleSubmit}>
            <Form.Item label='E-mail'>
              {getFieldDecorator('email', {
                rules: [
                  {
                    type: 'email',
                    message: 'The input is not valid E-mail!',
                  },
                  {
                    required: true,
                    message: 'Please input your E-mail!',
                  },
                ],
              })(<Input />)}
            </Form.Item>
          </Form>
        </Modal>
      </div>
    )
  }
}

const forgotPassword = Form.create()(ForgotPasswordModal)

export default forgotPassword



// WEBPACK FOOTER //
// ./src/components/LoginForm/ForgotPasswordModal.js